<app-uni-page
  [parent]="this"
  pageTitle="Inventory: Scan & Reconcile"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>

<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <!-- Toolbar: manufacturer + product type + status chips -->
    <div class="qb-list-actions">
      <div class="flex items-center gap-4 flex-wrap">
        <button
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          icon="pi pi-search"
          (click)="selectManufacturer()"
        >
          <span>Select Manufacturer</span>
        </button>
        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Manufacturer:</label>
          <span class="text-sm">{{ selectedManuf?.name || "(none selected)" }}</span>
        </div>

        <p-divider layout="vertical" class="mx-2 h-8" />

        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Product Type:</label>
          <p-select
            [options]="searchProductTypes"
            [(ngModel)]="selectedProductType"
            optionLabel="style"
            [filter]="true"
            filterBy="style"
            (ngModelChange)="onProductTypeSelected()"
            [showClear]="true"
            placeholder="Select Product Type"
            class="w-40"
          ></p-select>
        </div>

        <p-divider layout="vertical" class="mx-2 h-8" />

        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Status:</label>
          <p-selectButton
            [options]="statusChoices"
            [ngModel]="selectedStatusIds"
            (ngModelChange)="onSelectedStatusIdsChange($event)"
            optionLabel="name"
            optionValue="id"
            [multiple]="true"
          ></p-selectButton>
        </div>
      </div>
    </div>

    <!-- Grid -->
    <app-ag-grid [gridOptions]="itdGridOptions" class="flex-1 min-h-0"></app-ag-grid>

    <!-- Cell templates -->
    <ng-template #selectItemDetailCell let-row>
      <button pButton type="button" class="p-button-text p-button-sm" (click)="selectItemDetail(row)">Mark as Scanned</button>
    </ng-template>
    <ng-template #viewLogCell let-row>
      <button pButton type="button" class="p-button-text p-button-sm" (click)="viewLog(row)">View Log</button>
    </ng-template>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
